import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {WorkrequestLndWViewmodel} from '../workrequest-lnd-w-viewmodel';
import {FormControl, Validators} from '@angular/forms';
import {RefDataService} from '../../../shared/services/ref-data.service';
import {LoginService} from '../../../shared/services/login.service';
import {RefDataItem, RefDataType} from '../../../shared/data-objects/ref-data-item';
import {FeeService} from '../../../shared/services/fee.service';
import {SERVICE_PROVIDER} from '../../../shared/services/fee.service';
import {WorkrequestLndWDetails} from '../workrequest-lnd-w-details';
import {AddressService} from '../../../shared/services/address.service';

@Component({
  selector: 'app-workrequest-lnd-w',
  templateUrl: './workrequest-lnd-w.component.html',
  styleUrls: ['./workrequest-lnd-w.component.css']
})
export class WorkrequestLndWComponent implements OnInit {
  @Input()
  isReadOnly = false;
  @Input()
  workRequestViewModel: WorkrequestLndWViewmodel;
  @Input()
  propertyDescription: string;
  @Output()
  selectedItemUpdated = new EventEmitter();
  items: RefDataItem[];
  developmentNameControl: FormControl;
  numberOfLotsControl: FormControl;
  propertyDescriptionControl: FormControl;
  stageControl: FormControl;

  within1To10LotsRequiredControl: FormControl;
  greaterThan10LotsRequiredControl: FormControl;

  developmentNameControlMaxLength = 100;
  developmentNameControlMinLength = 1;

  propertyDescriptionControlMaxLength = 100;
  propertyDescriptionControlMinLength = 1;

  stageControlMaxLength = 10;
  stageControlMinLength = 1;

  maximumLots = 5000;
  numberRegEx = /^[0-9]*$/;

  pricingZone: string = SERVICE_PROVIDER.CWW;

  constructor(private loginService: LoginService, private addressService: AddressService
    , private refDataService: RefDataService, private feeService: FeeService) {
    if (!this.workRequestViewModel) {
      this.workRequestViewModel = new WorkrequestLndWViewmodel();
    }
    if (!this.workRequestViewModel.workrequestDetails) {
      this.workRequestViewModel.workrequestDetails = new WorkrequestLndWDetails();
    }

    this.developmentNameControl = new FormControl('', [Validators.compose([
      Validators.maxLength(this.developmentNameControlMaxLength),
      Validators.minLength(this.developmentNameControlMinLength)
    ])]);

    this.numberOfLotsControl = new FormControl('', [Validators.compose([Validators.min(0),
      Validators.max(this.maximumLots), Validators.pattern(this.numberRegEx)])]);

    this.propertyDescriptionControl = new FormControl({value: '', disabled: true}, [Validators.compose([
      Validators.required,
      Validators.maxLength(this.propertyDescriptionControlMaxLength),
      Validators.minLength(this.propertyDescriptionControlMinLength)
    ])]);

    this.stageControl = new FormControl('', [Validators.compose([
      Validators.maxLength(this.stageControlMaxLength),
      Validators.minLength(this.stageControlMinLength)
    ])]);


    this.within1To10LotsRequiredControl = new FormControl({value: true, disabled: true});
    this.greaterThan10LotsRequiredControl = new FormControl({value: false, disabled: true});

    // fetch pricing zone (CWW / WW)
    this.addressService.getPricingZone().subscribe(_pricingzone => {
      this.pricingZone = _pricingzone.toUpperCase() === SERVICE_PROVIDER.WW ? SERVICE_PROVIDER.WW : SERVICE_PROVIDER.CWW;
      console.log('PrizeZone:', this.pricingZone);
    }, err => {
      this.pricingZone = SERVICE_PROVIDER.CWW;
    });
  }

  ngOnInit() {
    const pleaseSelect: RefDataItem[] = [new RefDataItem(0, 'Please Select...')];
    this.refDataService.retrieveReferenceData(RefDataType.Zones, this.loginService.getToken()).subscribe(
      (refDataItems) => {
        this.items = pleaseSelect.concat(refDataItems);
        for (let i = 0; i < this.items.length; i++) {
          if ((<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).currentZoningSelectedItemId === this.items[i].id) {
            this.selectedItemId = Number(this.items[i].id);
            break;
          }
        }
      },
      err => {
      });
    this.loadFees();
  }

  get totalOrderAmount(): number {
    return this.workRequestViewModel.workrequestDetails.totalOrderAmount;
  };

  public calculateTotalAmount(): void {
    this.workRequestViewModel.workrequestDetails.totalOrderAmount = (this.greaterThan10LotsRequired ?
      this.greaterThan10LotsAmount : 0) + (this.within1To10LotsRequired ? this.within1To10LotsAmount : 0);
  }

  loadFees(): void {
    this.feeService.retrieveFees('LandDevelopment', this.loginService.getToken(), ok => {
        if (ok) {
          this.workRequestViewModel.within1To10LotsAmount = this.feeService.getWithin1To10LotsAmount(this.pricingZone);
          this.workRequestViewModel.greaterThan10LotsAmount = this.feeService.getGreaterThan10LotsAmount(this.pricingZone);
          this.calculateTotalAmount();
        } else {
          console.log('no fees found');
        }
      },
      err => {
        // Log errors if any
        console.log(err);
      });
  }

  onLotsChange(): void {
    if (!this.workRequestViewModel) {
      return;
    }

    if (!this.workRequestViewModel.workrequestDetails.numberOfLots ||
      this.workRequestViewModel.workrequestDetails.numberOfLots === 0) {
      (<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).within1To10LotsRequired = false;
      (<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).greaterThan10LotsRequired = false;
    } else if (this.workRequestViewModel.workrequestDetails.numberOfLots > 0
      && this.workRequestViewModel.workrequestDetails.numberOfLots <= 10) {
      this.within1To10LotsRequired = true;
      this.greaterThan10LotsRequired = false;
    } else if (this.workRequestViewModel.workrequestDetails.numberOfLots > 10) {
      this.within1To10LotsRequired = false;
      this.greaterThan10LotsRequired = true;
    }
  }

  public get selectedItem(): RefDataItem {
    if (this.items == null) {
      return null;
    }
    for (const i of this.items) {
      if (Number(i.id) === Number(this.selectedItemId)) {
        return i;
      }
    }
    return null;
  }

  public set selectedItem(theItem: RefDataItem) {
    if (theItem != null) {
      this.selectedItemId = Number(theItem.id);
    }
  }

  public onSelectedItemChange(event: any): void {
    this.selectedItemUpdated.emit(Number(this.selectedItem));
  }

  get selectedItemId(): number {
    return (<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).currentZoningSelectedItemId;
  }

  set selectedItemId(v: number) {
    (<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).currentZoningSelectedItemId = v;
  }

  get developmentName(): string {
   return this.workRequestViewModel.workrequestDetails.developmentName;
  }

  set developmentName(v: string) {
    this.workRequestViewModel.workrequestDetails.developmentName = v;
  }

  get numberOfLots(): number {
    return this.workRequestViewModel.workrequestDetails.numberOfLots;
  }

  set numberOfLots(v: number) {
    this.workRequestViewModel.workrequestDetails.numberOfLots = v;
    this.onLotsChange();
  }

  get stage(): string {
    return this.workRequestViewModel.workrequestDetails.stage;
  }

  set stage(v: string) {
    this.workRequestViewModel.workrequestDetails.stage = v;
  }

  isGuestUserLoggedIn(): boolean {
    return this.loginService.isGuestUserLoggedIn();
  }

  get errorMessage(): string {
    return this.workRequestViewModel.errorMessage;
  }

  set errorMessage(v: string) {
    this.workRequestViewModel.errorMessage = v;
  }

  get within1To10LotsAmount(): number {
    return this.workRequestViewModel.within1To10LotsAmount;
  }

  get greaterThan10LotsAmount(): number {
    return this.workRequestViewModel.greaterThan10LotsAmount;
  }

  get within1To10LotsRequired(): boolean {
    if (this.workRequestViewModel.workrequestDetails && this.workRequestViewModel.workrequestDetails) {
      return (<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).within1To10LotsRequired;
    }
    return false;
  }

  set within1To10LotsRequired(v: boolean) {
    (<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).within1To10LotsRequired = v;
    (<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).greaterThan10LotsRequired = !v;
    this.calculateTotalAmount();
  }

  get greaterThan10LotsRequired(): boolean {
    return (<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).greaterThan10LotsRequired;
  }

  set greaterThan10LotsRequired(v: boolean) {
    (<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).greaterThan10LotsRequired = v;
    (<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).within1To10LotsRequired = !v;
    this.calculateTotalAmount();
  }

  displayErrorMessage(): string {
    this.workRequestViewModel.invalidSelectionError = '';
    this.developmentNameControl.markAsTouched();
    this.numberOfLotsControl.markAsTouched();
    this.propertyDescriptionControl.markAsTouched();
    this.stageControl.markAsTouched();

    this.errorMessage = null;

    let errorText = '';

    if (this.developmentNameControl.invalid) {
      if (this.developmentNameControl.hasError('maxlength')) {
        errorText += 'Development name cannot exceed ' +
          this.developmentNameControlMaxLength + ' characters' + '<br>';
      }

      if (this.developmentNameControl.hasError('minlength')) {
        errorText += 'Development name should be greater than' +
          this.developmentNameControlMinLength + ' characters' + '<br>';
      }

      if (this.developmentNameControl.hasError('required')) {
        errorText += 'Please enter Development name' + '<br>';
      }
    }

    if (this.numberOfLotsControl.invalid) {
      if (this.numberOfLotsControl.hasError('required')) {
        errorText += 'Please enter Number of lots' + '<br>';
      }

      if (this.numberOfLotsControl.hasError('pattern')) {
        errorText += 'Please enter numbers only in Number of lots' + '<br>';
      }
    } else if (this.numberOfLots <= 0) {
      errorText += 'Please enter Number of lots' + '<br>';
    }

    if (this.propertyDescriptionControl.invalid) {
      if (this.propertyDescriptionControl.hasError('maxlength')) {
        errorText += 'Property description cannot exceed ' +
          this.propertyDescriptionControlMaxLength + ' characters' + '<br>';
      }

      if (this.propertyDescriptionControl.hasError('minlength')) {
        errorText += 'Property description should be greater than' +
          this.propertyDescriptionControlMinLength + ' characters' + '<br>';
      }

      if (this.propertyDescriptionControl.hasError('required')) {
        errorText += 'Please enter Property description' + '<br>';
      }
    }

    if (this.stageControl.invalid) {
      if (this.stageControl.hasError('maxlength')) {
        errorText += 'Stage cannot exceed ' +
          this.stageControlMaxLength + ' characters' + '<br>';
      }

      if (this.stageControl.hasError('minlength')) {
        errorText += 'Stage should be greater than' +
          this.stageControlMinLength + ' characters' + '<br>';
      }

      if (this.stageControl.hasError('required')) {
        errorText += 'Please enter Stage' + '<br>';
      }
    }

    if ((<WorkrequestLndWDetails>this.workRequestViewModel.workrequestDetails).currentZoningSelectedItemId === 0) {
      errorText += 'Please select Current zoning' + '<br>';
    }

    this.markValidationControlsAsUntouched();
    this.errorMessage = errorText.length > 0 ? errorText : null;
    return errorText;
  }

  get invalidSelectionError(): string {
    return this.workRequestViewModel.invalidSelectionError;
  }

  markValidationControlsAsUntouched() {
    this.developmentNameControl.markAsUntouched();
    this.numberOfLotsControl.markAsUntouched();
    this.propertyDescriptionControl.markAsUntouched();
    this.stageControl.markAsUntouched();
    this.loadFees();
  }

  get getCssClass(): string {
    if (!this.isGuestUserLoggedIn()) {
      if (this.isReadOnly) {
        return 'form-control';
      }

      return 'no-border col-md-6';
    }

    return 'form-control';
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/lnd-w-form/workrequest-lnd-w/workrequest-lnd-w.component.ts